import { Phone, MessageSquare } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[var(--border-soft)] sticky-cta-shadow"
      data-testid="sticky-mobile-cta"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a href="tel:+16149664283" className="h-14 rounded-md bg-money text-white font-bold flex items-center justify-center gap-2" data-testid="mobile-call-btn">
          <Phone size={18} /> Call Now
        </a>
        <a href="sms:+16149664283" className="h-14 rounded-md border-2 border-navy text-navy font-bold flex items-center justify-center gap-2" data-testid="mobile-sms-btn">
          <MessageSquare size={18} /> Text Us
        </a>
      </div>
    </div>
  );
}
